import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { CommandPanels, EditorControls, withBaseEditor } from '../../BaseEditor';
import { DocGrid } from '../../../components/Styled/grids/editorGrid';

const ThisDocGrid = styled(DocGrid)`
  grid-template-areas:  "name";
  
  @media (max-width: 600px) {
  display: block;
  }
`;

function EditorRenderer({
  getControl, currentUser, data, fields, dataSetter,
}) {
  return (
    <ThisDocGrid>
      {currentUser.is_superuser && (
        <Grid item sm={12}>
          {getControl('org', {
            backend: '/api/catalog/orgs/',
          })}
        </Grid>
      )}
      <Grid item sm={12} display="flex" container spacing={2}>
        <Grid item sm={2}>
          {getControl('date')}
        </Grid>
        <Grid item sm={4}>
          {getControl('number')}
        </Grid>
      </Grid>
      <Grid item sm={12} display="flex" container spacing={2}>
        <Grid item sm={6}>
          {getControl('ato_name')}
        </Grid>
      </Grid>
      <Grid item sm={4}>
        {getControl('part_land')}
      </Grid>
      <Grid item sm={12}>
        <EditorControls.TextInput
          label={fields.notes.label}
          readOnly={fields.notes.read_only}
          required={fields.notes.required}
          value={data.notes}
          onChange={(e, v) => dataSetter({ notes: v })}
        />
      </Grid>
    </ThisDocGrid>
  );
}

EditorRenderer.propTypes = {
  getControl: PropTypes.func.isRequired,
  dataSetter: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    org: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
      addr_prefix: PropTypes.string,
    }),
    is_superuser: PropTypes.bool,
  }).isRequired,
  fields: PropTypes.shape({
    notes: PropTypes.shape({
      label: PropTypes.string,
      required: PropTypes.bool,
      read_only: PropTypes.bool,
    }),
  }).isRequired,
  data: PropTypes.shape({
    notes: PropTypes.string,
  }).isRequired,
};

export default withBaseEditor(EditorRenderer, '/api/realty/sessiondecisions/', CommandPanels.catCommandPanel);
